import React from 'react';
import { IDocument } from '../../store/slices/documents';
import classes from './DocumentList.module.css';
import folderIcon from '../../assets/icons/white-folder-icon.svg';
import checkGreen from '../../assets/icons/check-green.svg';
import deleteIcon from '../../assets/icons/deleteIcon.svg';
import commentIcon from '../../assets/icons/comment-icon.svg';
import downloadIcon from '../../assets/icons/arrow-down-circle.svg';
import { format } from 'date-fns';
import { IAttachment } from '../UI/SelectedSalesOrder/DigitalHealthProfileTab';
import { CommentDialog } from './CommentDialog';

import { MediaPlayer } from '../UI/AudioPlayer/MediaPlayer';
import { useTranslation } from '../../hooks/useTranslations';

type Props = {
  document: IDocument | IAttachment;
  mimeType: string;
  hideComment?: boolean;
  handleDelete?: () => void;
  isLoading?: boolean;
  userInfo?: any;
  newDocumentModal?: boolean;
  isUploading?: boolean;
  hideDownload?: boolean;
};

const DocumentCard: React.FC<Props> = ({
  document,
  mimeType,
  hideComment,
  isLoading,
  userInfo,
  newDocumentModal,
  isUploading,
  handleDelete,
  hideDownload,
}) => {
  const [showComment, setShowComment] = React.useState<boolean>(false);
  const isAudio = ['audio/wav', 'audio/mp3', 'audio/mpeg'].includes(mimeType);
  const isImage = ['image/jpeg', 'image/png', 'image/jpg'].includes(mimeType);
  const isVideo = ['video/webm', 'webm', 'video/mp4', 'mp4'].includes(mimeType);
  const mimeName = mimeType.split('/').length > 1 ? mimeType.split('/')[1] : mimeType;
  const isDocumentToUpload = isUploading;
  const isLocallDocument = !document.attachment_id;
  const { translations } = useTranslation();

  return (
    <div
      className={
        isDocumentToUpload ? `${classes.documentCard} ${classes.garyBg}` : `${classes.documentCard}`
      }
    >
      {isLoading && <div className={classes.loading} />}
      {!newDocumentModal && (
        <div className={classes.header}>
          {document.person_firstname && document.person_lastname
            ? `${document.person_firstname} ${document.person_lastname}`
            : userInfo
            ? `Customer: ${userInfo.person_firstname} ${userInfo.person_lastname} |`
            : ''}

          {document?.datetime_created
            ? format(new Date(document.datetime_created), ' dd.MM.yy, HH:mm')
            : ''}
          {isVideo && (
            <div className={classes.documentActions}>
              {!hideComment && document.comment && document.comment !== '' && (
                <img
                  alt={'comment'}
                  className={classes.commentIcon}
                  src={commentIcon}
                  onClick={() => setShowComment(true)}
                />
              )}
              {isDocumentToUpload ? (
                <img
                  style={{ marginLeft: 5, height: 26, width: 26 }}
                  className={classes.actionIcon}
                  src={checkGreen}
                  alt="arrow"
                />
              ) : !isImage ? (
                <div
                  className={classes.downloadButton}
                  onClick={() => {
                    window.open(`${document.link}`);
                  }}
                >
                  {/* {translations('download')} */}
                  <img style={{ marginLeft: 5 }} src={downloadIcon} alt="arrow" />
                </div>
              ) : (
                <a
                  className={classes.downloadButton}
                  href={document.link}
                  rel="noreferrer"
                  target="_blank"
                >
                  {/* {translations('download')} */}
                  <img style={{ marginLeft: 5 }} src={downloadIcon} alt="arrow" />
                </a>
              )}
              {handleDelete && hideDownload && (
                <img
                  onClick={handleDelete}
                  className={classes.deleteIcon}
                  src={deleteIcon}
                  alt="arrow"
                />
              )}
            </div>
          )}
        </div>
      )}
      {!isVideo && (
        <div className={classes.documentTopContainer}>
          {isAudio ? (
            <div className={classes.documentFileName}>
              {document.title && document.title !== ''
                ? `${document.title}.${mimeName}`
                : document.name}
            </div>
          ) : (
            <img src={folderIcon} alt="folder" style={{ width: 48 }} />
          )}
          {!isAudio && !isVideo && (
            <div className={classes.documentInfoContainer}>
              <div className={classes.documentFileName}>
                {document.title
                  ? `${document.title}.${mimeName}`
                  : `${document.name ? document.name : ''}`}
              </div>
              <div className={classes.documentInfo}>
                {document.fileSize
                  ? parseFloat(`${document.fileSize / 1000000}`).toFixed(2) +
                    ' ' +
                    translations('size.mb') +
                    ' ● '
                  : ''}
                {mimeName}
              </div>
            </div>
          )}

          <div className={classes.documentActions}>
            {!hideComment && document.comment && document.comment !== '' && (
              <img
                alt={'comment'}
                className={classes.commentIcon}
                src={commentIcon}
                onClick={() => setShowComment(true)}
              />
            )}
            {isDocumentToUpload ? (
              <img
                style={{ marginLeft: 5, height: 26, width: 26 }}
                className={classes.actionIcon}
                src={checkGreen}
                alt="arrow"
              />
            ) : !isImage ? (
              <div
                className={classes.downloadButton}
                onClick={() => {
                  window.open(`${document.link}`);
                }}
              >
                {/* {translations('download')} */}
                <img style={{ marginLeft: 5 }} src={downloadIcon} alt="arrow" />
              </div>
            ) : (
              <a
                className={classes.downloadButton}
                href={document.link}
                rel="noreferrer"
                target="_blank"
              >
                {/* {translations('download')} */}
                <img style={{ marginLeft: 5 }} src={downloadIcon} alt="arrow" />
              </a>
            )}
            {handleDelete && hideDownload && (
              <img
                onClick={handleDelete}
                className={classes.deleteIcon}
                src={deleteIcon}
                alt="arrow"
              />
            )}
          </div>
        </div>
      )}
      {isAudio && (
        <div className={classes.audioWrapper}>
          <MediaPlayer
            mediaType="audio"
            url={document.link ?? ''}
            urlType={isLocallDocument ? 'blob' : 'attachment'}
          />
          {/* {'transcription_text' in document && (
            <>
              <p className={classes.transcriptionTitle}>Transcription</p>
              <div className={classes.transcriptionDes}>
                {(document as IDocument).transcription_text}
              </div>
            </>
          )} */}
        </div>
      )}
      {isVideo && (
        <div className={classes.videoContainer}>
          <MediaPlayer
            style={{
              width: 270,
              height: 'fit-content',
              alignSelf: 'center',
              display: isDocumentToUpload ? 'none' : 'block',
            }}
            mediaType="video"
            url={document.link ?? ''}
            urlType={isLocallDocument ? 'blob' : 'attachment'}
          />
          {newDocumentModal && <img src={folderIcon} alt="folder" style={{ width: 48 }} />}
          <div className={classes.videoContent}>
            <div className={classes.documentFileName}>
              {document.title && document.title !== ''
                ? `${document.title}.${mimeName}`
                : document.name}
            </div>
            <div className={classes.documentInfo}>{mimeName}</div>

            {/* {'transcription_text' in document && (
              <>
                <p className={classes.transcriptionTitle}>{translations('transcription')}</p>
                <div className={classes.transcriptionDes}>
                  <ReadMore textLimit={400}>{(document as IDocument).transcription_text}</ReadMore>
                </div>
              </>
            )} */}
          </div>
        </div>
      )}

      {showComment && !hideComment && (
        <CommentDialog
          document={document}
          isOpen={showComment}
          onClose={() => setShowComment(false)}
        />
      )}
    </div>
  );
};

export { DocumentCard };
